import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-bootstrap/Modal";
import "./styles.css";
import { translateText } from "../../utilities";
import { languagesList } from "../../common/languages";
import { Spinner } from "react-bootstrap";

export const TranslatePopup = ({
  showTranslation,
  setShowTranslation,
  mainTitle,
  type,
  categoryListing,
  text,
}) => {
  const [selectedTranslation, setSelectedTranslation] = useState("en");
  const [list, setList] = useState([]);
  const [translatedList, setTranslatedList] = useState([]);
  const isTextMode = typeof text === "string";

  useEffect(() => {
    getTheCurrentList();
  }, [type, text]);

  const getTheCurrentList = async () => {
    if (isTextMode) {
      setList(text.trim() ? [{ description: text }] : []);
      return;
    }
    setList(
      categoryListing?.filter((item) => item.type == type)[0]?.dataListing ||
        []
    );
  };

  const translatedData = async () => {
    const dataList = [];
    for (let item of list) {
      const response = await translateText(
        item.description,
        selectedTranslation
      );
      dataList.push({
        ...item,
        description: response,
      });
    }
    setTranslatedList(dataList);
  };

  useEffect(() => {
    if (selectedTranslation && list.length > 0) {
      if (selectedTranslation == "en") {
        setTranslatedList(list);
      } else {
        translatedData();
      }
    }
  }, [selectedTranslation, list]);

  return (
    <Modal
      show={showTranslation}
      size="lg"
      onHide={() => setShowTranslation(false)}
      animation={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {isTextMode ? mainTitle || "" : `My ${mainTitle || ""}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <select
            className="searchFieldItem"
            title="Select Language"
            value={selectedTranslation}
            onChange={({ target: { value } }) => {
              setSelectedTranslation(value);
            }}
          >
            {languagesList.length > 0 &&
              languagesList.map(({ code, language }, index) => {
                return (
                  <option key={index} value={code}>
                    {language}
                  </option>
                );
              })}
          </select>

          {list && list.length > 0 && (
            <div className="listContainer">
              {translatedList.length == list.length ? (
                list.map(({ description }, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        margin: 10,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "15px",
                          fontWeight: "bold",
                          marginTop: "5px",
                          color: "#47B6F6",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {description}
                      </span>
                      <span style={{ whiteSpace: "pre-wrap" }}>
                        {translatedList[index].description}
                      </span>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flex: 1,
                  }}
                >
                  <Spinner animation="grow" />
                </div>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
